import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'csi-form-template-date-field-config',
  templateUrl: './form-template-date-field-config.component.html',
  styleUrls: ['./form-template-date-field-config.component.css']
})
export class FormTemplateDateFieldConfigComponent implements OnInit {
  @Input() templateFieldFormGroup: FormGroup;

  constructor() {}

  ngOnInit() {}
}
